export default __webpack_public_path__ + "static/media/information--tunnel--g3.d2ceeebb.png";